export default {
	navbar: {
		home: '开发者首页',
		doLogin: '立即登录',
		document: '文档中心',
		regist: '免费注册',
		login: {
			control: '控制中心',
			logOut: '退出登录'
		},
		notice: {
			logOut: {
				title: '系统提示',
				message: '确认退出登录？',
				confirm: '立即退出',
				cancel: '暂不退出',
			}
		}
	},
	login: {
		title: '密码登录',
		account: '邮箱/用户名',
		password: '登录密码',
		remember: '记住账号',
		forgot: '忘记密码？',
		btn: '登录',
		control: '控制中心',
		switch: '切换账号',
		loginRule: {
			username: '请输入邮箱或用户名',
			password: '请输入登录密码'
		}
	},
	home: {
		introduce: '什么是JOSH Cloud？',
		introDoc: 'JOSH Cloud是为广大开发者搭建的智能物联网设备管理系统，用户可管理设备及应用程序，自行开发应用程序上传至平台，并将应用程序远程推送到设备上运行。',
		regist: '加入JOSH Cloud',
		registDoc: '用户可通过JOSH Cloud账号加入并使用平台，首次登录后建议用户首先完善个人信息，以便使用平台中各项功能。（注：忘记密码操作需要账号邮箱，请优先激活！）',
		registContent: {
			step1: '注册开发者账号',
			step2: '登录JOSH Cloud',
			step3: '激活登录邮箱',
			step4: '绑定/激活安全邮箱'
		},
		develop: 'JOSH Cloud使用指南',
		devDoc: 'JOSH Cloud是为广大开发者搭建的智能物联网设备管理系统，本教程旨对平台使用流程、操作方法进行全面描述与讲解，以便开发者更快的熟悉平台功能。',
		sdk: 'SDK使用教程',
		sdkDoc: '本教程通过IDE使用说明、开发板安装调试教学及开发板介绍等几部分教程，指导开发者快速上手开发调试开发板应用程序，并提供大量API使用示例供开发者参考。',
		vm: 'JoshVM开放文档',
		vmDoc: '文档施工中……',
		community: 'Josh开发者社区',
		communityLink: 'JOSH开发者社区是面向开发者的开放型技术平台。包含问答、技术分享、资源下载等模块，以分享专业、优质、高效的技术为主要目标，帮助技术人快速成长与发展。' 
	},
	navMenu: {
		overview: '监测/概览',
		deviceManage: '设备管理',
		device: '设备',
		group: '分组',
		task: '任务',
		certificate: '证书管理',
		appManage: '应用管理',
		user: '个人账户',
		helpDoc: '帮助文档',
		server: '平台服务',
		serverAudio: '语音服务',
	},
	server: {
		noData: '暂无数据',
		audio: {
			key: 'ApiKey',
			secret: 'ApiSecret',
			table: {
				orderIndex: '序号',
				name: '服务项',
				limit: '使用限制'
			}
		}
	},
	userinfo: {
		title: '个人信息',
		username: '用户名',
		telephone: '手机号',
		nickname: '昵称',
		edit: '修改',
		add: '添加',
		captchaTip: '',
		// captchaTip: '图形验证码需区分大小写',
		backGet: '获取邮箱激活码',
		editAvatar: '修改头像',
    loginMailbox: '登录邮箱',
    emailActiveCode: '邮箱激活码',
    securityEmailActiveCode: '安全邮箱激活码',
    next: '下一步',
    toActive: '去激活',
    nickname: '昵称',
    secureMailbox: '安全邮箱',
    deviceNumber: '设备数量',
    groupNumber: '分组数量',
    resetPassword: '重置密码',
    captcha: '图形验证码',
    activateMailbox: '激活邮箱',
    activateSafeMailbox: '激活安全邮箱',
    authentication: {
    	authentication: '身份验证',
    	tips: '修改账户信息需输入安全验证码进行身份验证，安全验证码已发送至安全邮箱',
    	tipsTwo: '请前往查看',
    	regain: '重新获取',
    	confirm: '确定'
    },
    editPassword: {
    	resetPassword: '重置密码',
    	oldPassword: '旧密码',
    	newPassword: '新密码',
    	newPasswordTip: '密码由6-20位数字与字母组成',
    	confirmPassword: '确认密码',
    	confirm: '确认',
    	editRule: {
    		oldPassword: '请输入旧密码',
    		newPassword: '请输入新密码',
    		newPasswordError: '密码需由6-20位数字与字母组成',
    		confirm: '请再次确认密码',
    		confirmError: '两次密码不同，请重新确认'
    	}
    },
    editNickname: {
    	title: '修改昵称',
    	add: '添加昵称',
    	confirm: '确认',
    	newNckname: '新昵称',
    	editRule: {
    		newNickname: '请输入新昵称',
    	}
    },
    editTelephone: {
    	title: '绑定手机号',
    	smsCode: '短信验证码',
    	backGet: '获取短信验证码',
    	getAgain: '后重新获取',
    	confirm: '确认',
    	telephone: '手机号',
    	editRule: {
    		telephone: '请输入手机号',
    		errorTel: '手机号格式错误，请重新输入',
    		captcha: '请输入图形验证码',
    		code: '请输入短信验证码',
    	}
    },
    editSecurityEmail: {
    	editEmail: '修改安全邮箱',
    	addEmail: '添加',
    	confirm: '确认',
    	newEmail: '新安全邮箱',
    	editRule: {
    		newSecurityEmail: '请输入新安全邮箱',
    		newSecurityEmailError: '邮箱格式错误，请重新填写',
    	}
    },
    editLoginEmail: {
    	editEmail: '修改登录邮箱',
    	confirm: '确认',
    	newEmail: '新登录邮箱',
    	captcha: '图形验证码',
    	editRule: {
    		newLoginEmail: '请输入新登录邮箱',
    		newLoginEmailError: '邮箱格式错误，请重新填写',
    		captcha: '请输入图形验证码',
    		emailActiveCode: '请输入邮箱激活码',
    		securityEmailActiveCode: '请输入安全邮箱激活码'
    	}
    },
    editAvatar: {
    	changePic: '更换图片',
    	editAvatar: '修改头像',
    	upload: '上传'
    },
    deviceType: {
    	title: '使用限制',
    	noData: '暂无数据',
    	orderIndex: '序号',
    	name: '设备类型',
    	authType: '鉴权方式',
    	total: '数量上限',
    	noLimit: '不限'
    }
	},
	control: {
		overview:{
			title: '监控/概览',
			deviceNum: '设备数量',
			groupNum: '分组数量',
			appNum: '应用数量',
			taskNum: '任务数量',
			activeNum: '激活数量',
			onlineNum: '在线数量',
			isDoing: '进行中',
			goBuy: '去购买'
		},
		device: {
			list: {
				title: '设备列表',
				deviceNumber: '设备编号',
				deviceName: '设备名称',
				deviceType: '设备类型',
				IMEI: 'IMEI',
				missionState: '任务状态',
				grouping: '所属分组',
				appInfo: '应用信息',
				activeState: '激活状态',
				connectState: '连接状态',
				lastOnlineTime: '最后在线时间',
				select: '请选择',
				noData: '暂无数据',
				otherSet: '其它设置',
				connectionSettings: '连接检查设置',
				setCheck: '设为检查',
				setNoCheck: '设为不检查',
				checkStatus: '连接检查状态',
				check: '检查',
				noCheck: '不检查',
				choseDevice: '请选择要设置的设备',
				confirmSet: '确定设为',
				confirm: '确定',
				tips: '提示',
				operateSuccess: '操作成功',
				cancel: "已取消",
				operate: '操作',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',
				applyDelete: '申请删除',
				remove: '移除',
			},
			create: {
				title: '添加设备',
				deviceName: '设备名称',
				IMEI: 'IMEI',
				groups: '所属分组',
				type: '类型',
				select: '请选择',
				confirm: '确定',
				rule: {
					name: '请输入设备名称',
					imei: '请输入IMEI',
					deviceType: '请选择设备类型'
				}
			},
			detail: {
				title: '设备详情',
				deviceNumber: '设备编号',
				deviceName: '设备名称',
				createTime: '添加时间',
				getCode: '获取激活码',
				getPaper: '生成证书',
				code: '激活码',
				paperNotic: '生成的证书将覆盖原有证书，且平台不做保存，请妥善管理',
				expireTime: '过期时间',
				copy: '复制',
				copySuccess: '复制成功',
				lastConnectTime: '最后连接时间',
				group: '所属分组',
				deviceType: '设备类型',
				activeState: '激活状态',
				connectState: '连接状态',
				connectCheck: '连接检查状态',
				appInfo: '应用信息',
				taskRecord: '任务记录',
				logList: '日志记录',
				app: {
					appList: '应用列表',
					addApp: '添加应用',
					name: '名称',
					version: '版本号',
					mainClass: '主类名',
					remark: '备注',
					state: '状态',
					createTime: '安装时间',
					operate: '操作'
				},
				task: {
					taskRecord: '任务记录',
					addTask: '添加任务',
					taskNumber: '任务编号',
					taskType: '任务类型',
					select: '请选择',
					startTime: '开始日期',
					endTime: '结束日期',
					to: '至',
					noData: '暂无数据',
					createTime: '发起时间',
					remake: '备注',
					otherSet: '其它设置',
					appInfo: '应用信息',
					launchTime: '发起时间',
					endTime: '完成时间',
					deviceNum: '设备数量',
					finishNum: '完成数量',
					taskState: '任务状态',
					operate: '操作',
					add: '添加',
					query: '搜索',
					empty: '清空条件',
					look: '查看',
					delete: '删除',
					serialNumber: '序号',
				},
				log: {
					logList: '日志列表',
					reportType: '上报类型',
					reportContent: '上报内容',
					reportTime: '上报时间',
					taskNumber: '任务编号',
					taskItemNumber: '任务项编号',
					createTime: '发起时间',
					query: '搜索',
					empty: '清空条件',
					serialNumber: '序号',
				}
			}
		},
		group: {
			list: {
				title: '分组列表',
				groupNumber: '分组编号',
				groupName: '分组名称',
				createTime: '创建时间',
				addTime: '添加时间',
				deviceNum: '设备数量',
				startTime: '开始日期',
				endTime: '结束日期',
				to: '至',
				noData: '暂无数据',
				operate: '操作',
				remake: '备注',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',
			},
			create: {
				editTitle: '修改分组',
				title: '添加分组',
				groupName: '分组名称',
				remake: '备注',
				confirm: '确定',
				rule: {
					name: '请输入分组名称'
				}
			},
			detail: {
				title: '分组详情',
				groupNumber: '分组编号',
				groupName: '分组名称',
				createTime: '添加时间',
				deviceNum: '设备数量',
				activeNum: '激活数量',
				onlineNum: '在线数量',
				remake: '备注',
				deviceList: '设备列表',
				taskRecord: '任务记录'
			}
		},
		task: {
			list: {
				title: '任务列表',
				taskNumber: '任务编号',
				taskType: '任务类型',
				select: '请选择',
				startTime: '开始日期',
				endTime: '结束日期',
				to: '至',
				noData: '暂无数据',
				createTime: '创建时间',
				remake: '备注',
				otherSet: '其它设置',
				appInfo: '应用信息',
				launchTime: '发起时间',
				endTime: '完成时间',
				deviceNum: '设备数量',
				finishNum: '完成数量',
				operate: '操作',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',
			},
			create: {
				title: '添加任务',
				taskNumber: '任务编号',
				taskType: '任务类型',
				configure: '配置',
				remark: '任务备注',
				selectDevice: '选择设备',
				selectGroup: '选择分组',
				abstract: '摘要',
				appSelect: '应用选择',
				number: '编号',
				name: '名称',
				type: '类型',
				rule: {
					taskNumber: '请输入任务编号',
					type: '请选择任务类型'
				}
			},
			detail: {
				title: '任务详情',
				taskNumber: '任务编号',
				taskType: '任务类型',
				otherSet: '其它设置',
				deviceNum: '设备数量',
				appName: '应用名称',
				finishNum: '完成数量',
				version: '版本号',
				createTime: '创建时间',
				remake: '备注',
				deviceList: '设备列表',
				finalReport: '最后上报内容',
				taskState: '任务状态',
				updateTime: '更新时间'
			}

		},
		cert: {
			list: {
				title: '证书列表',
				certNumber: '证书编号',
				certName: '证书名称',
				relation: '关联设备数量',
				select: '请选择',
				state: '状态',
				enable: '启用',
				disable: '禁用',
				createTime: '创建时间',
				noData: '暂无数据',
				operate: '操作',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',

			},
			create: {
				title: '添加证书',
				certName: '证书名称',
				cert: '证书',
				publicKey: '公有私钥',
				privateKey: '私有密钥',
				download: '下载',
				confirm: '确认'
			},
			detail: {
				title: '证书详情',
				certNumber: '证书编号',
				certName: '证书名称',
				state: '状态',
				download: '下载',
				deviceNum: '设备数量',
				publisher: '发布者',
				theme: '主题',
				createDate: '创建日期',
				effectiveDate: '生效日期',
				expirationDate: '到期日期'
			}
		},
		app: {
			list: {
				title: '应用列表',
				appName: '应用名称',
				version: '版本号',
				mainClass: '主类名',
				remake: '备注',
				uploadTime: '上传时间',
				deleteState: '删除状态',
				operate: '操作',
				noData: '暂无数据',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',

			},
			create: {
				editTitle: '修改应用',
				title: '添加应用',
				appName: '应用名称',
				version: '版本号',
				mainClass: '主类名',
				file: '源文件',
				selectFile: '选择文件',
				remake: '备注',
				confirm: '确定',
				cDelete: '确定移除 ',
				rule:{
					name: '请输入应用名称',
					version: '请输入版本号',
					mainClass: '请输入主类名',
					file: '请上传文件',
					remark: '请输入备注'
				}
			},
			detail: {
				title: '应用详情',
				appName: '应用名称',
				version: '版本号',
				uploadTime: '上传时间',
				mainClass: '主类名',
				remake: '备注',
				file: '源文件',
				download: '下载',
				delete: '删除'
			}
		}
	},
	regist: {
		login: '去登录',
		title: '注册开发者账号',
		username: '设置用户名',
		usernameTip: '5-25个字符，不区分大小写，用户名一旦设置成功无法修改',
		email: '请输入邮箱',
		emailTip: '请输入未绑定过的邮箱，邮箱可在控制中心内修改',
		password: '设置您的登录密码',
		passwordTip: '登录密码由6-20位数字与字母组成',
		confirm: '请再次输入登录密码',
		agreement1: '《JOSH开发者协议》',
		agreement2: '《隐私权政策》',
		btn: '立即注册',
		registRule: {
			usernameEmpty: '请输入用户名',
			usernameError: '用户名长度需在 5 到 25 个字符',
			emailEmpty: '请输入邮箱',
			emailError: '邮箱格式异常，请检查',
			passwordEmpty: '请设置您的登录密码',
			passwordError: '登录密码由6-20位数字与字母组成',
			confirmEmpty: '请再次输入登录密码',
			confirmError: '两次密码不同，请重新确认',
		}
	},
	forgot: {
		step1: '账号校验',
		step1Tip: '输入账号用户名或邮箱获取安全验证码',
		step2: '获取安全验证码',
		step2Tip: '登录安全邮箱获取验证码并回填',
		step3: '重置密码',
		step3Tip: '重新设置账号登录密码',
		back: '返回',
		success: '密码重置成功',
		btn: '去登录'
	},
	forgotStep1: {
		username: '邮箱/用户名',
		captcha: '图片验证码',
		captchaTip: '看不清，点击换一张',
		btn: '获取安全验证码',
		rule: {
			account: '请输入用户名或邮箱',
			captcha: '请输入图片验证码'
		}
	},
	forgotStep2: {
		code: '安全验证码',
		codeTip: '安全校验码已发送至账号安全邮箱，请前往查看',
		btn: '下一步',
		rule: {
			code: '请输入安全验证码'
		}
	},
	forgotStep3: {
		password: '新密码',
		passwordTip: '登录密码由6-20位数字与字母组成',
		confirm: '请再次输入新密码',
		btn: '完成',
		rule: {
			passwordEmpty: '请设置您的新密码',
			passwordError: '密码由6-20位数字与字母组成',
			confirmEmpty: '请再次输入新密码',
			confirmError: '两次密码不同，请重新确认',
		}
	},
	confirm: {
		confirm: '确认',
		cancel: '取消',
		deleteImmediately: '立即删除',
		applyImmediately: '立即申请',
		removeImmediately: '立即移除',
    noDeletion: '暂不删除',
    notRemoved: '暂不移除',
    notApply: '暂不申请',
    tips: '提示',
    process: '处理中...',
    deleteApp: '确定删除该应用吗？',
    deleteGroup: '确定删除该分组吗？',
    deleteCert: '确定删除该证书？',
    deleteDevice: '确定删除该设备？',
    applyDeleteDevice: '确定申请删除该设备？',
    removeDevice: '确定移除该设备？',
    deleteTask: '确定删除该任务？',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    operateSuccess: '操作成功，',
    deviceDelete: '设备已删除',
    deviceApplyDelete: '设备已申请删除',
    deviceRemove: '设备已移除',
    groupDelete: '分组已删除',
    taskDelete: '任务已删除',
    appDelete: '应用已删除',
    certDelete: '证书已删除',
    activeSuccess: '激活成功',
    bindPhone: '当前账户未绑定手机号，请移步至“个人账户”绑定手机号',
    toBind: '去绑定',
    bindSuccess: '绑定成功',
    getPaper: '生成的证书将覆盖原有证书，原有证书将失效，是否生成证书？',
	},
	tips: {
		bindPhone: {
			addDevice: '注：当前账户无法添加设备，请先前往',
			useAudio: '注：当前账户无法使用语音服务，请先前往',
			page: '个人账户',
			action: '绑定手机号'
		}
	},
	fixedBar: {
		feedback: '意见反馈',
		backTop: '返回顶部',
	},
	stApply: {
		title: 'ST板卡申请计划书',
		item: {
			pjname: '项目名称',
			name: '姓名',
			telephone: '联系电话',
			college: '院校/院系',
			email: '邮箱',
			address: '快递地址',
			post: '邮编',
			introduce: '项目引言',
			background: '项目背景',
			summary: '需求概述',
			field: '应用领域',
			device: '板卡选择',
			time: '开发周期',
			timeBegin: '开始日期',
			timeSplit: '至',
			timeEnd: '结束日期',
			reason: '申请出发点',
			btn: '确认提交',
		},
		rules: {
			input: '请填写',
			select: '请选择',
			emailError: '邮箱格式异常，请检查',
			telephoneError: '手机号格式异常，请检查',
		},
		notice: {
			title: '您尚未登录',
			content: '申请ST板卡前请先登录JOSH Cloud',
			btn: '去登录',
		}
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh.js